// extracted by mini-css-extract-plugin
export default {"headline":"partners-module__headline--ptR","subheader":"partners-module__subheader--kqg"};